import { Reveal, MaskedLine } from "@/components/Kinetic";
import EditorialMarquee from "@/components/Marquee";

const ARTIST_IMG =
  "https://customer-assets-v7afamib.emergentagent.net/job_soundwave-shop-10/artifacts/3p2bphn4_IMG_3187.PNG";

const CHAPTERS = [
  {
    num: "01",
    title: "THE ORIGIN",
    body: "Raised where the streetlights hum and the bass rattles trunk lids, Mike Millzz turned late nights on the block into a language. Southern Smoke Music Group started in a bedroom studio with one mic, one beat machine, and zero permission slips.",
  },
  {
    num: "02",
    title: "THE SOUND",
    body: "Smoke over neon. Gospel roots dragged through 808s, chopped hooks, and verses that don't flinch. Every track is built for 2AM drives — windows down, city glowing blue.",
  },
  {
    num: "03",
    title: "THE MOVEMENT",
    body: "Southern Smoke isn't a label, it's a family. Every show, every drop, every freestyle is for the ones who were counted out early. The Circle keeps growing because the story keeps being true.",
  },
  {
    num: "04",
    title: "THE LEGACY",
    body: "GET-LOW is just the opening chapter. The EP is loaded, the tour is mapping, and the mission stays the same: make the South impossible to ignore.",
  },
];

export default function About() {
  return (
    <main data-testid="about-page" className="pb-40 pt-36">
      <div className="mx-auto max-w-7xl px-6">
        <p className="mb-4 font-mono text-xs tracking-[0.4em] text-primary">THE ARTIST</p>
        <h1 data-testid="about-title" className="font-anton leading-[0.9]">
          <MaskedLine className="text-6xl text-white md:text-8xl" delay={0.1}>ABOUT</MaskedLine>
          <MaskedLine className="text-outline glow-blue text-6xl md:text-8xl" delay={0.25}>MILLZZ</MaskedLine>
        </h1>
      </div>

      <div className="mx-auto mt-20 grid max-w-7xl items-start gap-16 px-6 lg:grid-cols-2">
        <Reveal className="lg:sticky lg:top-32">
          <div data-testid="about-portrait-frame" className="relative border border-primary/40 p-3">
            <div className="absolute -left-px -top-px h-8 w-8 border-l-2 border-t-2 border-primary" />
            <div className="absolute -bottom-px -right-px h-8 w-8 border-b-2 border-r-2 border-primary" />
            <img
              src={ARTIST_IMG}
              alt="Mike Millzz — GET-LOW artwork"
              data-testid="about-portrait-image"
              className="w-full object-cover"
            />
            <p className="mt-3 flex justify-between font-mono text-[10px] tracking-[0.3em] text-white/50">
              <span>GET-LOW — OFFICIAL ARTWORK</span>
              <span className="text-primary">@MIKE_MILLZZ_</span>
            </p>
          </div>

          <div data-testid="about-stats" className="mt-10 grid grid-cols-3 divide-x divide-white/10 border border-white/10">
            {[
              ["12M+", "STREAMS"],
              ["48", "SHOWS"],
              ["1", "EP OUT NOW"],
            ].map(([v, l]) => (
              <div key={l} className="p-6 text-center">
                <p className="font-anton text-3xl text-primary md:text-4xl">{v}</p>
                <p className="mt-1 font-mono text-[10px] tracking-[0.25em] text-white/50">{l}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <div data-testid="about-chapters" className="space-y-20">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <div data-testid={`about-chapter-${c.num}`} className="border-l-2 border-primary/40 pl-8">
                <span className="font-mono text-sm tracking-[0.4em] text-primary">{c.num}</span>
                <h2 className="mt-3 font-anton text-4xl text-white md:text-5xl">{c.title}</h2>
                <p className="mt-5 leading-relaxed text-white/65">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <EditorialMarquee
        className="mt-32"
        outline
        speed={40}
        items={["THE SOUTH AIN'T WHISPERING", "SOUTHERN SMOKE MUSIC GROUP", "MIKE MILLZZ"]}
      />
    </main>
  );
}
